<div class="container">
    <finder-button
        [ariaLabel]="displayText"
        anchor="true"
        (click)="toggleState()"
        class="button"
    >
        {{ displayText }}
        <finder-font-icon name="pulldown" class="rotate" size="m" *ngIf="showLessArrow"></finder-font-icon>
        <finder-font-icon name="pulldown" size="m" *ngIf="showMoreArrow"></finder-font-icon>
    </finder-button>
</div>
